<ng-container *ngIf="!checking; else spinner">
  <pba-template-auth *ngIf="partner$ | async as partner">
    <form
      *ngIf="!enable2Fa && !enableVerifyEmail"
      [formGroup]="loginForm"
      (submit)="login()"
      class="w-full"
      novalidate
      #form="ngForm"
    >
      <div class="frame-content flex flex-col justify-center items-center wh-full gap-4">
        <div class="flex flex-col items-center w-full gap-2">
          <div
            class="action-header-login"
            [class]="isNext || isInputPassword ? 'justify-between w-full' : 'justify-center'"
          >
            <mat-icon
              *ngIf="isNext || !isInputCredential || isInputPassword"
              (click)="onPrev()"
              color="primary"
              class="left !size-[30px] cursor-pointer"
              >navigate_before</mat-icon
            >
            <div class="title">Sign in</div>
          </div>
          <div *ngIf="isNext || isInputPassword" class="flex items-center gap-1.5">
            <mat-icon class="!size-4 !text-[16px]">mail_outline</mat-icon>{{ credential.value }}
          </div>
        </div>
        <ng-container *ngIf="!isNext && isInputCredential; else inputPassword">
          <mat-form-field class="wh-full input-password">
            <mat-label>Sign-in ID</mat-label>
            <input
              (input)="showErrorSummary = false"
              matInput
              autocomplete="new-password"
              placeholder="Enter your email"
              formControlName="credential"
              required
            />
            <mat-error *ngIf="credential.invalid">{{ getErrorCredential() }}</mat-error>
          </mat-form-field>
          <div class="noti-summary error" *ngIf="showErrorSummary">{{ error }}</div>

          <button
            mat-raised-button
            [style.backgroundColor]="credential.valid ? partner.loginButtonBackground : ''"
            [disabled]="credential.invalid || indicator"
            color="primary"
            class="w-full"
            (click)="onNextStep()"
          >
            Next
          </button>
        </ng-container>

        <ng-template #inputPassword>
          <ng-container *ngIf="isInputPassword">
            <div class="wh-full flex flex-col gap-2">
              <mat-form-field class="wh-full">
                <mat-label>Password</mat-label>
                <input
                  (input)="showErrorSummary = false"
                  [type]="showPassword ? 'text' : 'password'"
                  matInput
                  autocomplete="new-password"
                  formControlName="password"
                  required
                />
                <button type="button" mat-icon-button matSuffix (click)="showPassword = !showPassword">
                  <mat-icon>{{ showPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                </button>
                <mat-error *ngIf="password.invalid">{{ getErrorPassword() }}</mat-error>
              </mat-form-field>
              <div class="flex justify-end w-full">
                <a routerLink="/auth/resetpassword">Forgot password?</a>
              </div>
            </div>
            <div class="noti-summary error" *ngIf="showErrorSummary">{{ error }}</div>
            <button
              mat-raised-button
              [loading]="indicator"
              [style.backgroundColor]="loginForm.valid && !indicator ? partner.loginButtonBackground : ''"
              [disabled]="loginForm.invalid || indicator"
              class="w-full"
              color="primary"
              type="submit"
            >
              Sign in
            </button>
          </ng-container>
        </ng-template>
      </div>

      <div class="progress-spinner">
        <mat-progress-spinner
          class="mb-5"
          *ngIf="loadingOption"
          strokeWidth="2"
          mode="indeterminate"
          diameter="25"
        ></mat-progress-spinner>
      </div>

      <ng-container *ngIf="isNext && !isInputPassword && ssoLoginButtons$ | async as ssoLoginButtons">
        <div
          *ngIf="!enable2Fa && !enableVerifyEmail && ssoLoginButtons.length"
          class="flex flex-col items-center sso-container"
        >
          <b3n-sso-login-button
            *ngFor="let sso of ssoLoginButtons"
            [authorizeProvider]="sso.authorizeProvider"
            [url]="sso.url"
            [text]="sso.text"
            [rememberMe]="rememberMe.value"
            [returnUrl]="returnUrl"
            [email]="credential.value"
            (inputPassword)="isInputPassword = true; isNext = false"
            class="w-full"
          ></b3n-sso-login-button>
          <div class="flex items-center justify-center w-full">
            <mat-checkbox
              *ngIf="showRememberMe()"
              color="primary"
              formControlName="rememberMe"
              class="remember-checkbox"
            >
              Remember me
            </mat-checkbox>
          </div>
        </div>
      </ng-container>
    </form>

    <ng-container *ngIf="!enable2Fa && !enableVerifyEmail && isOnlinePayment">
      <div class="no-account">
        <div>Don't have an account?</div>
        <button mat-button color="primary" (click)="navigate2Signup()">Sign up</button>
      </div>
    </ng-container>

    <pba-login2fa
      *ngIf="enable2Fa && !enableVerifyEmail"
      [partner]="partner"
      [loginForm]="loginForm"
      [loginResponse]="loginResponse"
      (resetLogin)="enable2Fa = false"
      (completedLogin)="onCompletedExtraStep()"
      class="wh-full"
    ></pba-login2fa>

    <pba-add-email
      *ngIf="enableVerifyEmail"
      [partner]="partner"
      (updatedEmail)="onCompletedExtraStep()"
      class="wh-full"
    ></pba-add-email>
  </pba-template-auth>
</ng-container>

<ng-template #spinner>
  <div class="spinner-container">
    <mat-spinner [diameter]="40" [strokeWidth]="2"></mat-spinner>
  </div>
</ng-template>
